import { productShowcase } from '@/content/site';
import { ScrollReveal } from '@/components/ScrollReveal';
import { Section } from '@/components/Section';
import { trackCtaClick, trackWhatsAppSalesClick } from '@/lib/tracking';
import './ProductShowcase.css';

export function ProductShowcase() {
  return (
    <Section
      title={productShowcase.title}
      lead={productShowcase.lead}
      className="product-showcase"
    >
      <ScrollReveal>
        <div className="product-showcase__frame glass-card">
          <div className="product-showcase__chrome" aria-hidden="true">
            <span />
            <span />
            <span />
          </div>
          <div className="product-showcase__mock">
            <aside className="product-showcase__sidebar">
              <div className="product-showcase__nav-item product-showcase__nav-item--active">
                Inbox
              </div>
              <div className="product-showcase__nav-item">Agentes</div>
              <div className="product-showcase__nav-item">Calendario</div>
              <div className="product-showcase__nav-item">Analítica</div>
            </aside>
            <div className="product-showcase__main">
              <div className="product-showcase__header">Conversaciones activas</div>
              <ul className="product-showcase__threads">
                <li>
                  <strong>WhatsApp · Consulta precios</strong>
                  <span>IA respondiendo</span>
                </li>
                <li>
                  <strong>Web · Reserva turno</strong>
                  <span>Agendado automáticamente</span>
                </li>
                <li>
                  <strong>Instagram · Seguimiento</strong>
                  <span>Derivado a operador</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="product-showcase__actions">
          <a
            href={productShowcase.ctaPrimaryHref}
            className="btn btn-primary"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() =>
              trackWhatsAppSalesClick(
                'product_showcase',
                productShowcase.ctaPrimary,
                productShowcase.ctaPrimaryHref,
              )
            }
          >
            {productShowcase.ctaPrimary}
          </a>
          <a
            href={productShowcase.ctaSecondaryHref}
            className="btn btn-secondary"
            onClick={() =>
              trackCtaClick(
                'product_showcase',
                productShowcase.ctaSecondary,
                productShowcase.ctaSecondaryHref,
              )
            }
          >
            {productShowcase.ctaSecondary}
          </a>
        </div>
      </ScrollReveal>
    </Section>
  );
}
